import { useEffect } from "react";
import { RelativeComponentLoader } from "@/components/loader";
import { deleteExportLineageItem, getExportLineageItem } from "@/helpers/apis";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { Card, CardContent, LoadingButton, Stack, Typography } from "@altimateai/lego";
import { ApiHelper } from "@altimateai/ui-components/lineage";
import { Lineage } from "@altimateai/ui-components/lineage";
import { toast } from "@altimateai/lego";
import { BackButton } from "@/components/button";
import { useBreadcrumb } from "@/components/breadcrumbs";
import { LineageTracking } from "@/lib/tracking/lineage";

export const ExportLineage = () => {
  const navigate = useNavigate();
  const { itemId } = useParams();
  useBreadcrumb(itemId ?? "Details", {
    defaultParents: [{ label: "Export Lineage", pathname: "/collaboration/export-lineage" }],
  });
  const { data, isPending: isLoading } = useQuery({
    queryKey: ["GET-EXPORT-LINEAGE", itemId],
    queryFn: () => getExportLineageItem(itemId!),
  });

  // Handle successful data fetch (replaces onSuccess callback removed in TanStack Query v5)
  useEffect(() => {
    if (data) {
      // @ts-ignore
      ApiHelper.get = async (url: string, _data: Record<string, string>) => {
        console.log("ApiHelper", url, _data);
        switch (url) {
          case "getColumns": {
            if (!data?.lineage_data?.details) return {};
            const { columns, purpose } = data.lineage_data.details[_data.table];
            return {
              purpose: purpose,
              columns:
                columns?.map(c => ({
                  name: c.name,
                  table: c.table,
                  datatype: c.datatype,
                  can_lineage_expand: c.can_lineage_expand,
                  description: c.description,
                })) || [],
            };
          }
          default:
            break;
        }
      };
    }
  }, [data]);
  const { mutate: deleteItem, isPending: isDeleteLoading } = useMutation({
    mutationFn: () => deleteExportLineageItem(itemId ?? ""),
    onSuccess: () => {
      LineageTracking.exportDeleted(itemId ?? "");
      toast({ title: "Item deleted successfully" });
      navigate("/collaboration/export-lineage");
    },
    onError: err => {
      toast({ title: err instanceof Error ? err.message : String(err), variant: "destructive" });
    },
  });
  if (isLoading) {
    return <RelativeComponentLoader label="Loading..." />;
  }
  if (!data || !itemId) {
    return <Navigate to="/collaboration/export-lineage" />;
  }
  return (
    <div>
      <Stack className="mb-2 al-items-center">
        <BackButton defaultUrl="/collaboration/export-lineage" />
        <Typography variant="page-heading">{data.name}</Typography>
        <div className="spacer" />
        <LoadingButton
          loading={isDeleteLoading}
          size="sm"
          variant="destructive"
          onClick={() => deleteItem()}
        >
          Delete
        </LoadingButton>
      </Stack>
      <Card>
        <CardContent className="al-pt-4">
          <div style={{ height: "80vh" }}>
            <Lineage
              theme={"light"}
              staticLineage={data.lineage_data}
              lineageType={"static"}
              client="saas"
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
